import { useMemo } from 'react';
import { movies } from '@/mocks/movies';
import MovieCard from '@/components/feature/MovieCard';
import SectionHeading from '@/components/feature/SectionHeading';
import type { Movie } from '@/types/movie';

interface RelatedMoviesProps {
  current: Movie;
}

export default function RelatedMovies({ current }: RelatedMoviesProps) {
  const related = useMemo(() => {
    const scored = movies
      .filter((movie) => movie.id !== current.id)
      .map((movie) => {
        let score = 0;
        if (movie.type === current.type) score += 2;
        score += movie.genres.filter((genre) => current.genres.includes(genre)).length * 2;
        score += movie.actors.filter((actor) => current.actors.includes(actor)).length * 3;
        return { movie, score };
      })
      .filter((item) => item.score > 0)
      .sort((a, b) => b.score - a.score || b.movie.rating - a.movie.rating)
      .slice(0, 4)
      .map((item) => item.movie);

    return scored.length >= 4 ? scored : movies.filter((movie) => movie.id !== current.id).slice(0, 4);
  }, [current]);

  return (
    <section>
      <SectionHeading icon="ri-movie-line" title="相关推荐" subtitle="同类型或同主演的精彩作品" />
      <div className="grid grid-cols-2 gap-3 md:gap-4 lg:grid-cols-4">
        {related.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}